/* MODAL GESTION (global, attaché une seule fois) */

const sizeGuideModal = document.querySelector('.size-guide-modal');
const sizeGuideModalButton = document.querySelector('.size-guide-button button');
const sizeGuideModalCloseButton = document.querySelector('.size-guide-modal__close');

if (sizeGuideModal && sizeGuideModalButton && sizeGuideModalCloseButton) {

    sizeGuideModalButton.addEventListener('click', () => {
        sizeGuideModal.setAttribute('open', true);
    });

    sizeGuideModalCloseButton.addEventListener('click', () => {
        sizeGuideModal.removeAttribute('open');
    });

}

/* GESTION PAR INSTANCE (une boucle par .size-guide présente sur la page) */

const productSizeGuideItems = document.querySelectorAll('.size-guide');

productSizeGuideItems.forEach(productSizeGuide => {

    const option1 = productSizeGuide.querySelector('.size-group[data-option="option1"]');
    const option2 = productSizeGuide.querySelector('.size-group[data-option="option2"]');

    if (!option1 || !option2) return;

    const option1Select = option1.querySelector('select');
    const option2Select = option2.querySelector('select');
    const optionsSelect = productSizeGuide.querySelectorAll('.size-group select');

    const resultsContainer = productSizeGuide.querySelector('.results');
    const result1Container = resultsContainer.querySelector('.result-1');
    const result2Container = resultsContainer.querySelector('.result-2');

    const sizeCombinationsContainer = productSizeGuide.parentElement.querySelector('.size-combinations');

    function updateSelectedOptions() {

        const option1SelectedOption = option1Select.querySelector('option:checked');
        const option2Options = option2.querySelectorAll('option');

        option2Options.forEach(option2Option => {
            if (option2Option.getAttribute('for') != null && option2Option.getAttribute('for') != option1SelectedOption.value) {
                option2Option.setAttribute('hidden', true);
            } else {
                option2Option.removeAttribute('hidden');
            }
        });

    }
    updateSelectedOptions();

    function updateResults() {

        const option1SelectedOption = option1Select.querySelector('option:checked');
        const option2SelectedOption = option2Select.querySelector('option:checked');

        if (option1SelectedOption.value != '' && option2SelectedOption.value != '') {
            const sizeCombination = sizeCombinationsContainer.querySelector(`input[data-data-1="${option1SelectedOption.value}"][data-data-2="${option2SelectedOption.value}"]`);

            if (sizeCombination) {
                const result1 = sizeCombination.getAttribute('data-result-1');
                const result2 = sizeCombination.getAttribute('data-result-2');

                if (result1) {
                    result1Container.textContent = result1;
                }
                if (result2) {
                    result2Container.textContent = result2;
                }
            }

        }

    }

    option1Select.addEventListener('change', () => {
        option2Select.value = '';
        result1Container.textContent = '';
        result2Container.textContent = '';
        updateResults();
    });

    option2Select.addEventListener('change', () => {
        result1Container.textContent = '';
        result2Container.textContent = '';
    });

    optionsSelect.forEach(optionSelect => {
        optionSelect.addEventListener('change', () => {
            updateSelectedOptions();
            updateResults();
        });
    });

});
